import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import { useDisplayFilters } from "../../../api/useDisplayFilters";

const useDisplayFilterPreferencesState = createGlobalState({
  storage: "session",
  key: "useDisplayFilters",
  type: io.array(io.string),
  defaultValue: undefined,
  scoped: true,
});

const useDisplayFiltersVisibleState = createGlobalState({
  storage: "session",
  key: "displayFiltersVisible",
  type: io.boolean,
  defaultValue: true,
  scoped: true,
});

export function useDisplayFilterPreferences(projectId: string) {
  const displayFilters = useDisplayFilters(projectId);
  const [displayFilterStoredPreferences, setDisplayFilterPreferences] =
    useDisplayFilterPreferencesState({
      scope: projectId,
    });

  const [isFiltersSelectionVisible, setFiltersSelectionVisibility] = useDisplayFiltersVisibleState({
    scope: projectId,
  });

  const defaultFilterIds = displayFilters.filter(df => df.isDefault).map(f => f.id);
  const selectedFilterIds = displayFilterStoredPreferences ?? defaultFilterIds;
  const selectedFilterIdsSet = new Set(selectedFilterIds);
  const selectedUngroupedFilterIds: string[] = [];
  const selectedGroupedFilterIds: string[] = [];

  for (const displayFilter of displayFilters) {
    if (!selectedFilterIdsSet.has(displayFilter.id)) {
      continue;
    }

    if ((displayFilter.group?.trim() ?? "") === "") {
      selectedUngroupedFilterIds.push(displayFilter.id);
      continue;
    }

    selectedGroupedFilterIds.push(displayFilter.id);
  }

  return {
    selectedFilterIds,
    defaultFilterIds,
    selectedGroupedFilterIds,
    selectedUngroupedFilterIds,
    isFiltersSelectionAvailable: displayFilters.length > 0,
    isFiltersSelectionVisible,
    setDisplayFilterPreferences,
    setFiltersSelectionVisibility,
  };
}
